import groupByDate from "@irati/wallet/helpers/groupWalletItemsByDate"
import {LIST_SCHEDULED_TRANSFERS, CLEAR_SCHEDULED_TRANSFERS, ActionTypes} from "../actions/ScheduledTransfer"

const defaultState = {
  results: null
}

const ScheduledTransferReducer = (state = defaultState, action: ActionTypes) => {
  switch (action.type) {
    case LIST_SCHEDULED_TRANSFERS: {
      const {existingScheduledTransfers, newScheduledTransfers} = action
      return groupByDate(existingScheduledTransfers, newScheduledTransfers)
    }
    case CLEAR_SCHEDULED_TRANSFERS:
      return defaultState
    default:
      return state
  }
}

export default ScheduledTransferReducer
